var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainbowSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ed7850;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320,96c-141.4,0-256,114.6-256,256v96c0,17.7-14.3,32-32,32S0,465.7,0,448v-96C0,175.3,143.3,32,320,32s320,143.3,320,320v96c0,17.7-14.3,32-32,32s-32-14.3-32-32v-96c0-141.4-114.6-256-256-256ZM320,288c-35.3,0-64,28.7-64,64v96c0,17.7-14.3,32-32,32s-32-14.3-32-32v-96c0-70.7,57.3-128,128-128s128,57.3,128,128v96c0,17.7-14.3,32-32,32s-32-14.3-32-32v-96c0-35.3-28.7-64-64-64ZM160,352v96c0,17.7-14.3,32-32,32s-32-14.3-32-32v-96c0-123.7,100.3-224,224-224s224,100.3,224,224v96c0,17.7-14.3,32-32,32s-32-14.3-32-32v-96c0-88.4-71.6-160-160-160s-160,71.6-160,160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowSolid);
export default __webpack_public_path__ + "static/media/rainbow-solid.b72f36dd199e8ff87a77cf8642149ad4.svg";
export { ForwardRef as ReactComponent };